export default __webpack_public_path__ + "static/media/lockers.a1f7eab8.png";